module.exports = __webpack_public_path__ + "static/media/bg-mob-1@2x.138d065a.jpg";